import { render, staticRenderFns } from "./formatos_pedidos.vue?vue&type=template&id=633f0726"
import script from "./formatos_pedidos.vue?vue&type=script&lang=js"
export * from "./formatos_pedidos.vue?vue&type=script&lang=js"
import style0 from "./formatos_pedidos.vue?vue&type=style&index=0&id=633f0726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports